import ResultsSummary from './ResultsSummary';

export { type ResultsSummaryProps } from './ResultsSummary';
export default ResultsSummary;
